import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { KeyboardShortcutService, ShortcutDescription } from '../../../core/services/keyboard/keyboard-shortcut.service';

@Component({
  selector: 'app-keyboard-cheatsheet',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './keyboard-cheatsheet.component.html',
  styleUrl: './keyboard-cheatsheet.component.css',
})
export class KeyboardCheatsheetComponent implements OnChanges {
  @Input() visible = false;
  @Output() close = new EventEmitter<void>();

  private shortcutService = inject(KeyboardShortcutService);
  categories: { name: string; shortcuts: ShortcutDescription[] }[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['visible'] && this.visible) {
      this.loadShortcuts();
    }
  }

  private loadShortcuts(): void {
    const all = this.shortcutService.getDescriptions();
    const grouped = new Map<string, ShortcutDescription[]>();

    for (const s of all) {
      const cat = s.category || 'global';
      if (!grouped.has(cat)) grouped.set(cat, []);
      grouped.get(cat)!.push(s);
    }

    // Fixed order: global, navigation, form
    const order = ['global', 'navigation', 'form'];
    this.categories = order
      .filter(name => grouped.has(name))
      .map(name => ({ name, shortcuts: grouped.get(name)! }));

    // Add any remaining categories
    for (const [name, shortcuts] of grouped) {
      if (!order.includes(name)) {
        this.categories.push({ name, shortcuts });
      }
    }
  }

  onOverlayClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('cheatsheet-overlay')) {
      this.close.emit();
    }
  }
}
